import { Coupons, CouponsFilters } from './../../../commons/models/coupons';
import { ViewChild, Component, EventEmitter, Input, Output } from "@angular/core";

// Angular Material
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
// Rxjs
import { Observable } from "rxjs";
import { state, style, trigger } from '@angular/animations';
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';

export type CouponsColumn = "code" | "name" | "value" | "validFrom" | "validTo" | "actions";

@Component({
  selector: "app-coupons-list",
  templateUrl: "./coupons-list.component.html",
  styleUrls: ["./coupons-list.component.scss"],
  animations: [
    trigger("detailExpand", [
      state(
        "collapsed",
        style({ height: "0px", minHeight: "0", display: "none" })
      ),
      state("expanded", style({ height: "*" })),
    ]),
  ],
})
export class CouponsListComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input()
  coupons: Coupons[];

  // constructor() {
  //   console.log(this.coupons);
  // }

  @Input()
  selectedCoupons: Coupons[];

  @Input()
  defaultFilters: CouponsFilters;

  pageSizeOptions = PAGE_SIZE_OPTIONS;
  expandedElement: Coupons | null;

  @Input()
  total: Observable<number>;

  @Input()
  displayedColumns = [
    'code',
    'name',
    'validFrom',
    'validTo',
    'discountValue',
    'minOrderAmount',
    'maxOrderAmount',
    'maxUsesPerUser',
    'actions'
  ];

  @Input()
  canAdd: boolean;
  @Input()
  canEdit: boolean;
  @Input()
  canSelect: boolean;

  @Output()
  onLoad: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
  @Output()
  onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output()
  onFilterChange: EventEmitter<CouponsFilters> = new EventEmitter<CouponsFilters>();

  @Output()
  onSelectCoupon: EventEmitter<Coupons> = new EventEmitter<Coupons>();
  @Output()
  onAddCoupon: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onEditCoupon: EventEmitter<Coupons> = new EventEmitter<Coupons>();
  @Output()
  onShowCoupon: EventEmitter<Coupons> = new EventEmitter<Coupons>();
  @Output()
  onAddSelectedCoupon: EventEmitter<Coupons> = new EventEmitter<Coupons>();
  @Output()
  onRemoveSelectedCoupon: EventEmitter<Coupons> = new EventEmitter<Coupons>();

  get selectedItems(): boolean {
    return this.selectedCoupons.length > 0;
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort) => {
      this.onSortChange.emit(sort);
    });
    this.paginator.page.subscribe((pageEvent) => {
      this.onPageChange.emit(pageEvent);
    });
  }

  isSelected(coupon: Coupons): boolean {
    return this.selectedCoupons.map(obj => obj.code).includes(coupon.code);
  }

  addCoupon() {
    this.onAddCoupon.emit();
  }

  addSelectedCoupon(coupon: Coupons) {
    if(this.isSelectable(coupon)) {
      this.onAddSelectedCoupon.emit(coupon);
    }
  }

  isSelectable(coupon: Coupons): boolean {
    return !!coupon.code;
  }

  removeSelectedCoupon(coupon: Coupons) {
    this.onRemoveSelectedCoupon.emit(coupon);
  }

  toggleSelectedCoupon(coupon: Coupons) {
    if (this.isSelected(coupon)) {
      this.removeSelectedCoupon(coupon);
    } else {
      this.addSelectedCoupon(coupon);
    }
  }

  editCoupon(coupon: Coupons) {
    this.onEditCoupon.emit(coupon);
  }

  selectCoupon(coupon: Coupons) {
    this.onSelectCoupon.emit(coupon);
  }

  onFilter(filters: CouponsFilters) {
    this.paginator.firstPage();
    this.onFilterChange.emit(filters);
  }

  showCoupon(coupon: Coupons) {
    this.onShowCoupon.emit(coupon);
  }

  isAllSelected() {
    const numSelected = this.selectedCoupons.length;
    const numRows = this.coupons.filter(bl => this.isSelectable(bl)).length;
    return numSelected === numRows;
  }

  /** Seleziona tutte le righe se non sono tutte selezionate; altrimenti cancella la selezione */
  masterToggle() {
    this.isAllSelected() ?
        this.selectedCoupons.forEach(bl => this.removeSelectedCoupon(bl)) :
        this.coupons.forEach(bl => this.addSelectedCoupon(bl));
  }
}
